import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import PropTypes from 'prop-types';
import { IntlContext } from '@jutro/locale';
import _ from 'lodash';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import TWIAJobHelper from 'ent-capability-quoteandbind-common-react/util/TWIAJobHelper';
import metadata from './QuotePremium.metadata.json5';
import styles from './QuotePremium.module.scss'
import TFPACoverablesUtils from '../../../util/TFPACoverablesUtils';

function QuotePremium(props) {
    const { isComponentValid, submissionVM, updateCustomQuote, offeredQuote, continueButton,showAdditionalFieldError } = props;
    const [validCoverages, setValidCoverages] = useState();
    const intlContext = useContext(IntlContext);
    const isPolicyChange = TWIAJobHelper.isPolicyChange(submissionVM.value);

    useEffect(() => {
        setValidCoverages(() => isComponentValid)
    }, [isComponentValid]);

    const calculatePremiumAndQuote = useCallback(() => {
         updateCustomQuote()
    }, [updateCustomQuote])

    const diffCost = useCallback(() => {
        const transactionCost = _.get(offeredQuote, 'customQuoteExtension_TWIA.transactionCost_TWIA.amount')
        const formattedDiffCost = intlContext.formatNumber(transactionCost, {
            style: 'currency',
            currency: 'USD'
        });

        if (transactionCost > 0) {
            return `+${formattedDiffCost}`;
        }

        return formattedDiffCost;
    }, [intlContext, offeredQuote]);

    const getPremiumValue = useCallback(() => offeredQuote ? offeredQuote.premium.total : null, [offeredQuote]);

    const checkHO205Valid = useCallback(()=>
        _.get(submissionVM,"lobData.homeowners_tfpa.coverages.homeOfficeLiabDesc_Ext.aspects.valid") === false &&
        _.get(submissionVM,"lobData.homeowners_tfpa.coverages.medPayOthers_Ext.aspects.valid") === false,
        [submissionVM])

    console.log("quote Premium:",isComponentValid)
    console.log("quote Premium disabled button:",(validCoverages === false) || (!showAdditionalFieldError &&
        _.get(offeredQuote, 'premium.total') !== undefined))
    console.log("quote Premium showAdditionalFieldError:",showAdditionalFieldError,"+premium total:", _.get(offeredQuote, 'premium.total'))

    const overrideProps = {
        '@field': {
            labelPosition: 'left',
        },
        totalPremium: {
            visible: !showAdditionalFieldError &&
            _.get(offeredQuote, 'premium.total') !== undefined && !isPolicyChange,
            value: getPremiumValue()
        },
        break: {
            visible:!showAdditionalFieldError &&
            _.get(offeredQuote, 'premium.total') !== undefined,
        },
        totalPremiumReadOnly: {
            visible: showAdditionalFieldError ||
            _.get(offeredQuote, 'premium.total') === undefined
        },
        // DE17851
        calculatePremiumButton: {
           disabled:(validCoverages === false) || (!showAdditionalFieldError && _.get(offeredQuote, 'premium.total') !== undefined) ||
            (TFPACoverablesUtils.valuationCompleted(submissionVM) 
            && TFPACoverablesUtils.valuationRefresh(submissionVM) && TWIAJobHelper.isSubmission(submissionVM.value))
        },
        premiumDiff: {
            value: diffCost()
        },
        premiumLayout: {
            visible: !showAdditionalFieldError &&
                _.get(offeredQuote, 'premium.total') !== undefined && isPolicyChange
        },
        totalPremiumTitle:{
            visible: !isPolicyChange
        },
        totalAnnualPremium: {
            // eslint-disable-next-line no-secrets/no-secrets
            value: _.get(offeredQuote, 'customQuoteExtension_TWIA.totalAnnualPremium_TWIA')
        },
        currentPremium: {
            // eslint-disable-next-line no-secrets/no-secrets
            value: _.get(offeredQuote, 'customQuoteExtension_TWIA.previousTotalCost_TWIA')
        },
        adjustedPremium: {
            value: _.get(offeredQuote, 'customQuoteExtension_TWIA.totalCost_TWIA')
        },
        quotePremium: {
            className: !showAdditionalFieldError &&
            _.get(offeredQuote, 'premium.total') !== undefined && isPolicyChange 
            ? styles.premiumChangecardtfpa
            : styles.premiumcardtfpa
        },
        premiumContent: {
            className: !showAdditionalFieldError &&
            _.get(offeredQuote, 'premium.total') !== undefined && isPolicyChange 
            ? styles.premiumchangeinternaldiv
            : styles.premiuminternaldivtfpa
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
        },
        resolveCallbackMap: {
            updateAndQuote: calculatePremiumAndQuote
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={submissionVM}
            overrideProps={overrideProps}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
            callbackMap={resolvers.resolveCallbackMap}
        />
    );
}

QuotePremium.propTypes = {
    data: PropTypes.shape({}).isRequired,
};

export default QuotePremium;
